// extracted by mini-css-extract-plugin
module.exports = {"container":"BotaoOpcoes_container__1Guw7","bolinhas":"BotaoOpcoes_bolinhas__1q6zX"};